module.exports = __webpack_public_path__ + "img/hr-pipe-t-down.329dc8f7.png";